import { render, staticRenderFns } from "./Metamask.vue?vue&type=template&id=65316c5a&scoped=true&"
import script from "./Metamask.vue?vue&type=script&lang=ts&"
export * from "./Metamask.vue?vue&type=script&lang=ts&"
import style0 from "./Metamask.vue?vue&type=style&index=0&id=65316c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65316c5a",
  null
  
)

export default component.exports